import * as React from 'react';
import { Tree } from 'antd';

import { FormItem } from '../../../../components/Form';
import { privileges } from 'data-layer/src/services/Users/privileges';

export interface IPrivilegesSettingsProps {
  user: GQL.IUser;
  selectedPrivileges: string[];
  onChange: Function;
}

const privilegesTitles = {
  addingNewProducts: 'Add new products',
  editingProducts: 'Update products',
  changeProductPrice: 'Change product prices',
  deletingProducts: 'Delete products',
  userManagement: 'User management',
}

export default class PrivilegesSettings extends React.Component<IPrivilegesSettingsProps> {

  public render() {
    const { selectedPrivileges } = this.props;

    return (
      <>
        <FormItem label={'Privileges'}>
          <Tree
            onCheck={(checkedKeys: any, info: any) => this.onChangePrivileges(checkedKeys.checked)}
            onSelect={(checkedKeys: any, info: any) => this.onChangePrivileges(checkedKeys)}
            selectedKeys={selectedPrivileges}
            checkedKeys={selectedPrivileges}
            multiple={true}
            checkable={true}
            checkStrictly={true}
            treeData={
              Object.keys(privileges).map((privilege: string) => {
                return {
                  key: privileges[privilege],
                  title: privilegesTitles[privileges[privilege]]
                }
              })
            }
          />
        </FormItem>
      </>
    );
  }

  private onChangePrivileges(value: any) {
    this.onChange('privileges', value);
  }

  private onChange(name: string, value: any) {
    this.props.onChange({
      target: {
        name,
        value
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Users/UserDetail/components/Privileges.tsx